// extracted by css-extract-rspack-plugin
export default {"text-area":"text-area-xTR_vM","textArea":"text-area-xTR_vM"};